Event.on('Listing.fetchedData', function (data) {
    const $listingCount = $('.js-listing-count');

    $listingCount.each(function() {
        const $countElem = $(this);

        if ($countElem.hasAttr('data-plural')) {
            const listingPlural = $countElem.data('plural');

            $countElem.html(data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count));
        } else {
            $countElem.html(data.count);
        }
    });

    setTimeout(function () {
        buildTippy();
        fetchUserPrices();
    }, 250);
});

Form.buildSpinners = function() {
    Form.buildSpinnersInside('body');
}

Form.buildSpinnersInside = function(selector) {
    if (typeof jQuery.ui !== 'undefined') {
        $.widget( "ui.spinner", $.ui.spinner, {
            _format: function(value) {
                var $elem = $(this.element),
                    append = '';

                if ($elem.data('spinner-append')) {
                    append = $elem.data('spinner-append');
                }

                return _.template(Spinner.template)({
                    value: value,
                    append: append
                });
            },
            _parse: function(value) {
                return parseFloat(value);
            }
        });

        $(selector).find('input.ui-spinner').each(function() {
            var $spinner = $(this),
                options = Spinner.options;

            if ($spinner.data('spinner-step')) {
                const step = parseFloat($spinner.data('spinner-step')) || 1;

                options.step = step;
                options.numberFormat = "n";

                options.max = step * 999;
            }

            if ($spinner.attr('min')) {
                options.min = $spinner.attr('min');
            }

            if (!$spinner.data('uiSpinner')) {
                $(this).spinner(options);
            }
        });
    }
}

Form.rebuildSpinnersInside = function(selector) {
    if (typeof jQuery.ui !== 'undefined') {
        $(selector).find(".ui-spinner").spinner().spinner("destroy");
        Form.buildSpinnersInside(selector);
    }
}

Form.datepicker = function() {
    if (typeof jQuery.ui !== 'undefined' && typeof jQuery.ui.datepicker !== 'undefined') {
        $(".datepicker").datepicker({
            closeText: "Zavrieť",
            prevText: "&#x3C;Predchádzajúci",
            nextText: "Nasledujúci&#x3E;",
            currentText: "Dnes",
            monthNames: [ "január", "február", "marec", "apríl", "máj", "jún",
            "júl", "august", "september", "október", "november", "december" ],
            monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Máj", "Jún",
            "Júl", "Aug", "Sep", "Okt", "Nov", "Dec" ],
            dayNames: [ "nedeľa", "pondelok", "utorok", "streda", "štvrtok", "piatok", "sobota" ],
            dayNamesShort: [ "Ned", "Pon", "Uto", "Str", "Štv", "Pia", "Sob" ],
            dayNamesMin: [ "Ne", "Po", "Ut", "St", "Št", "Pia", "So" ],
            weekHeader: "Ty",
            dateFormat: "dd.mm.yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
        });
    }
}

Listing.fetchData = function(elem, options) {
    var $elem = $(elem),
        $holder = $elem.parents('.' + Listing.holderClass),
        $pager = $holder.find('.pager'),
        url = Url.removeParameter($elem.data('url'), 'page'),
        url = Url.removeParameter(url, 'start'),
        page = parseInt($elem.data('page')),
        newPage = page + 1,
        defaults = {
            async: true
        };

    if (options != undefined) {
        defaults = $.extend(defaults, options);
    }

    if (!$elem.hasAttr('data-preloader') || $elem.data('preloader')) {
        Eshop.preloader.show();
    }

    if (this.start == undefined) {
        this.start = document.URL.match(/start=([0-9]+)/) == null ? page : document.URL.match(/start=([0-9]+)/)[1];
    }

    Listing.customCallbacks.beforeFetch();

    if (defaults.fetchPage) {
        newPage = defaults.fetchPage;
    }
    var fetchData = {
        page: newPage,
        start: this.start
    };

    // get filter query params into fetchData
    var currentUrl = new URL(window.location.href).searchParams;
    if (currentUrl.get('f')) {
        fetchData.f = currentUrl.get('f');
    }

    $.ajax({
        url: url,
        data: fetchData,
        dataType: 'json',
        success: function(data) {
            if (newPage == $elem.data('max') ) {
                $pager.remove();
                $elem.remove();
            } else {
                $elem.data('page', newPage);
            }

            Listing.callbacks.update(data, true);
        },
        async: defaults.async
    });
};

Cart.customCallbacks.addedItem = function (form, response) {
    var $submitButton = $(form).find('[type="submit"]');

    if (!response.status) {
        $submitButton.addClass('has-error');
    }

    $submitButton
        .addClass('is-loaded')
        .removeClass('is-loading')
        .prop('disabled', false);

    if (checkResolution('ie')) {
        setTimeout(function () {
            $submitButton.removeClass('is-loaded');
        }, 1000);
    } else {
        $submitButton.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $submitButton.removeClass('is-loaded');
        });
    }
}

Event.on('Listing.changeView', function () {
    const $view = $('#filter-view'),
        value = $view.val();

    $('.js-fake-view').removeClass('active');
    $('.js-fake-view#' + value).addClass('active');

    $(".products")
        .removeClass("products--row")
        .removeClass("products--grid");
    $(".products").addClass("products--" + value);
});

Event.on('Cart.product.before_add', function (form) {
    $(form).find('[type="submit"]')
        .removeClass('has-error')
        .addClass('is-loading')
        .prop('disabled', true);
});

Eshop.alert = function (msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: checkResolution('cxs;xs') ? 'bottom' : 'top'
        },
        gap: 2,
        delay: 4500,
        mouse_over: 'pause',
        offset: {
            y: checkResolution('cxs;xs') ? 15 : 140
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
                    '<i class="ico ico-close" aria-hidden="true"></i>' +
                '</button>' +
                '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

$(function() {
    Listing.customCallbacks.afterFetch = function () {
        if ($('.js-pager-current-count').length) {
            $('.js-pager-current-count').html($('.listing').first().find('.listing__item').length);
        }
    }

    $(document).on('click', '.pager__load .c-btn', function () {
        $(this).addClass('is-loading');
    });

    $('body').on('click', '.pager__item:not(.is-disabled) a', function() {
        if ($('.js-catalog-header:visible').length) {
            $('.js-catalog-header:visible').slideHere(24);
        } else {
            $('.listing__holder').first().slideHere(24);
        }
    });

    fetchUserPrices();
});

function fetchUserPrices()
{
    var ids = {};
    var fetch = false;

    $('.fetch-price').each(function () {
        if ($(this).text().indexOf('...') != -1) {
            ids[$(this).data('id')] = $(this).data('bid');
            fetch = true;
        }
    });

    if (!fetch) {
        return;
    }

    $.get('/zistenie-cien', {ids: ids}, function (response) {
        for (const id in response) {
            if (response[id].no_quantity_discount) {
                $('.is-discount-holder[data-id=' + id + ']').each(function () {
                    $(this).html('<div class="is-item is-empty">Bez množstevnej zľavy</div>');
                });
            }

            $('.fetch-price[data-id=' + id + ']').each(function () {
                $(this).text(Format.price(response[id].price * (1 - parseFloat($(this).data('discount') ?? 0) / 100)));
            });
        }
    }, 'json');
}

var filterElem = document.getElementById("filter");

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        var categoryId = e.detail.category_id;

        document.getElementById('filterCategoryId').value = categoryId;
        Filter.submit();
    });

    filterElem.addEventListener("category.updated", function (e) {
        var category = e.detail.category;
        var headElem = document.getElementsByTagName('h1')[0];
        var heading = headElem.innerText;

        if (headElem.dataset.original === undefined) {
            headElem.dataset.original = heading;
        }

        headElem.innerText = headElem.dataset.original;
        if (category) {
            headElem.innerText += " - " + category.name;
        }
    });
}